import React from 'react';
import { TextField, Typography } from '@mui/material';

interface RateFieldProps {
    rate: number;
    error?: string;
    onChange: (value: number) => void;
}

export const RateField: React.FC<RateFieldProps> = ({
    rate,
    error,
    onChange
}) => {
    return (
        <TextField
            label="Rate"
            type="number"
            value={rate}
            onChange={(e) => onChange(parseFloat(e.target.value) || 0)}
            error={!!error}
            helperText={error}
            inputProps={{ min: 0, step: 0.01 }}
            size="small"
            fullWidth
            InputProps={{
                startAdornment: <Typography sx={{ mr: 1, color: 'text.secondary' }}>$</Typography>
            }}
        />
    );
};
